import { __assign } from "tslib";
import { safeDump, JSON_SCHEMA } from "js-yaml";
/**
 * 将一个值转换为 YAML 格式的字符串（序列化）。
 *
 * @category Serialization
 *
 * @public
 *
 * @param value - 输入值。
 * @param indent - 空格缩进数量（默认为 `2`）。
 * @param opts - 选项
 *
 * @returns 序列化后的字符串；如果序列化失败（例如包含循环引用）返回 `undefined`。
 */
export function yamlStringify(value, indent, opts) {
    if (indent === void 0) { indent = 2; }
    var result;
    try {
        result = safeDump(value, __assign({ indent: indent, schema: JSON_SCHEMA, skipInvalid: true, noRefs: true, noCompatMode: true }, opts));
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
    return result;
}
//# sourceMappingURL=yamlStringify.js.map